import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './_textarea.scss';

const propTypes = {
	/**
	 * Objeto de estado.
	 *  1. status (Contiene el estado)
	 *  2. msg (Contiene el mensaje)
	 */
	state: PropTypes.object,
	/**
	 * Atributo name asociado.
	 */
	name: PropTypes.string,
	/**
	 * Icono derecho.
	 */
	rightIcon: PropTypes.string,
	/**
	 * Descripción asociada.
	 */
	description: PropTypes.string,
	/**
	 * Cantidad de filas.
	 */
	rows: PropTypes.number,
	/**
	 * Clases adicionales.
	 */
	className: PropTypes.string,
};

const Textarea = props => {
	const { state, rightIcon, name, description, className, ...r } = props;
	const { status, msgs } = state || {};
	const rows = props.rows || 10;
	const classes = classNames('textarea', className, {
		'state--error right-icon': status === 'error',
		'state--success right-icon': status === 'success',
		'right-icon': rightIcon,
	});
	const mensajeError = msgs ? msgs[0].text : '';

	return (
		<div className={classes}>
			<textarea
				className="--arial"
				name={name}
				rows={rows}
				placeholder={props.placeholder}
				{...r}
			></textarea>

			{/*meta != undefined  && meta.error &&  meta.touched*/}
			{status === 'error' && <i className="right-icon icon-error-warning"></i>}

			{/*meta != undefined && !meta.error && meta.touched*/}
			{status === 'success' && <i className="right-icon icon-check-mark"></i>}

			{/*meta != undefined  && meta.error &&  meta.touched*/}
			{status === 'error' ? (
				<span className="description --fivexs">{mensajeError}</span>
			) : (
				description && <span className="description --fivexs">{description}</span>
			)}
		</div>
	);
};

Textarea.propTypes = propTypes;

export default Textarea;
